module.exports = __webpack_public_path__ + "img/jobmule_sottocategorie.db225d48.png";